export const LEGAL_RESTRICTIONS_LINK =
  "https://support.rentspree.com/en/screening-restrictions-and-limitations"

export const CRIMINAL_STATES_RESTRICTIONS_LINK =
  "https://support.rentspree.com/en/records-in-criminal-background-check"
